export const WEDDING_HB = 'wedding-hb';
export const WEDDING_WF = 'wedding-wf';